/** Primary section links (header, sidebar rail, mobile menu). */

export type SiteNavItem = {
    id: string;
    label: string;
    href: string;
};

export const SITE_NAV_HOME: SiteNavItem = {
    id: 'home',
    label: 'ראשי',
    href: '/',
};

/**
 * Static fallback when the category table is empty or has not loaded yet.
 * Prefer `buildSiteNavItems` with live non-archived categories.
 */
export const SITE_NAV_ITEMS: SiteNavItem[] = [
    SITE_NAV_HOME,
    { id: 'news', label: 'חדשות', href: '/category/news' },
    { id: 'crime', label: 'פלילי', href: '/category/crime' },
    { id: 'sports', label: 'ספורט', href: '/category/sports' },
    { id: 'transport', label: 'תחבורה', href: '/category/transport' },
    { id: 'business', label: 'עסקים', href: '/category/business' },
    { id: 'education', label: 'חינוך', href: '/category/education' },
];

/** Build nav from active categories (already sorted by sortOrder). */
export function buildSiteNavItems(
    categories: Array<{ key: string; name: string }>,
): SiteNavItem[] {
    if (categories.length === 0) return SITE_NAV_ITEMS;
    return [
        SITE_NAV_HOME,
        ...categories.map((category) => ({
            id: category.key,
            label: category.name,
            href: `/category/${category.key}`,
        })),
    ];
}
